// extracted by mini-css-extract-plugin
export var MFRTeam = "MFRTeam-module--MFRTeam--12VJj";
export var Grid = "MFRTeam-module--Grid--2_loz";